import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { ToppersBannerSectionBlock as Value } from "@reactivated";

// NOTE: faithful port of the legacy `offer-banner.html`. Every classname is
// load-bearing for the `_offers-list.scss` partial. `date_range`, `title` and
// `sub_title` were `|safe` CharBlock fields → rendered via
// dangerouslySetInnerHTML (with `?? ""` so a null value yields empty rather
// than the literal string "null").
//
// GAP: legacy used `href="{{ value.see_details.slug }}"`, but the serialized
// PageChooserBlock exposes only `{id, url, title}` — there is no `slug`. The
// slug-as-href was a legacy quirk; `see_details.url` is the correct absolute
// path. We use `see_details?.url ?? ""`, preserving the always-rendered anchor
// (empty href when the page chooser is unset), matching the OfferModule
// precedent.
type IProps = Immutable<{
    value: Value;
}>;

export const BannerSectionBlock = (props: IProps): React.JSX.Element => {
    const v = props.value;
    return (
        <div className="offer-list__banner">
            <div className="offer-list__banner-content">
                <h2
                    className="offer-list__banner-dates"
                    dangerouslySetInnerHTML={{ __html: v.date_range ?? "" }}
                />
                <h1
                    className="offer-list__banner-title"
                    dangerouslySetInnerHTML={{ __html: v.title ?? "" }}
                />
                <p
                    className="offer-list__banner-copy"
                    dangerouslySetInnerHTML={{ __html: v.sub_title ?? "" }}
                />
                <a
                    href={v.see_details?.url ?? ""}
                    title={t`see details`}
                    className="button"
                >
                    {t`See Details`}
                </a>
            </div>
        </div>
    );
};
